// Small helpers for employer + contact + resume upload endpoints.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function uploadResume(file) {
    const form = new FormData();
    form.append("file", file);
    const r = await axios.post(`${API}/upload/resume`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return r.data;
}

export async function fetchEmployerPending() {
    const r = await axios.get(`${API}/employer/admin/pending`);
    return r.data;
}

export async function approveEmployer(employerId) {
    return axios.post(`${API}/employer/admin/employers/${employerId}/approve`);
}

export async function rejectEmployer(employerId) {
    return axios.post(`${API}/employer/admin/employers/${employerId}/reject`);
}

export async function setJobStatus(jobId, status) {
    return axios.post(`${API}/employer/admin/jobs/${jobId}/status`, { status });
}

export async function fetchAllEmployerJobs(status) {
    const params = status ? { params: { status } } : {};
    const r = await axios.get(`${API}/employer/admin/jobs`, params);
    return r.data.jobs || [];
}

export async function setJobFeatured(jobId, featured) {
    return axios.post(`${API}/employer/admin/jobs/${jobId}/featured`, { featured: !!featured });
}

export async function fetchEmployerAnalytics() {
    const r = await axios.get(`${API}/employer/analytics`);
    return r.data;
}

export async function trackJobView(jobId) {
    try {
        await axios.post(`${API}/jobs/${encodeURIComponent(jobId)}/view`);
    } catch { /* silent — analytics is best-effort */ }
}
